import React, { useEffect, useState } from "react";
import {
	useLazyGetAutoCompleteSuggestionsQuery,
	useLazyGetPlaceDetailsQuery
} from "../../../../store/services/maps/maps.service";
import { useMap } from "@vis.gl/react-google-maps";
import { Autocomplete, TextField } from "@mui/material";
import { InvitationCoordinates } from "../../../../store/services/invitations/dto/invitations.dto";

interface PlacePrediction {
	description: string;
	place_id: string;
}

interface LocationSearchProps {
	onSelect: (coords: InvitationCoordinates) => void;
}

const LocationSearch: React.FC<LocationSearchProps> = ({ onSelect }) => {
	const [inputValue, setInputValue] = useState("");
	const [options, setOptions] = useState<PlacePrediction[]>([]);
	const [sessionToken, setSessionToken] = useState<string>("");
	const [fetchSuggestions] = useLazyGetAutoCompleteSuggestionsQuery();
	const [fetchPlaceDetails] = useLazyGetPlaceDetailsQuery();
	const map = useMap();

	useEffect(() => {
		setSessionToken(Math.random().toString(36).substring(2));
	}, []);

	useEffect(() => {
		if (!inputValue) {
			setOptions([]);
			return;
		}

		const fetchPredictions = async () => {
			fetchSuggestions({
				input: inputValue,
				sessiontoken: sessionToken,
				components: "country:eg" // bias to Egypt
			}).then(({ data, error }) => {
				if (data) {
					if (data.predictions) {
						setOptions(data.predictions);
					}
				}
				if (error) {
					console.log("error", error);
				}
			});
		};

		fetchPredictions();
	}, [inputValue, sessionToken]);

	const handleSelect = async (option: PlacePrediction | null) => {
		if (!option) return;

		fetchPlaceDetails({
			place_id: option.place_id,
			sessiontoken: sessionToken
		}).then(({ data, error }) => {
			if (data) {
				console.log(data);
				if (data.result?.geometry?.location) {
					const coords: InvitationCoordinates = {
						lat: data.result.geometry.location.lat,
						lng: data.result.geometry.location.lng
					};
					onSelect(coords);
					if (map) {
						map.panTo(coords);
						map.setZoom(15);
					}
				}
			}
			if (error) {
				console.log("error", error);
			}
		});
	};

	return (
		<Autocomplete
			freeSolo
			options={options}
			getOptionLabel={option => (typeof option === "string" ? option : option.description)}
			onInputChange={(_, value) => setInputValue(value)}
			onChange={(_, value) => handleSelect(value as PlacePrediction)}
			renderInput={params => (
				<TextField
					{...params}
					label="Search for a location"
					variant="outlined"
					fullWidth
					sx={{ backgroundColor: "#fff" }}
				/>
			)}
		/>
	);
};

export default LocationSearch;
